// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-button {
  position: fixed;
  top: 8px;
  right: 6px;
  color: rgb(252, 252, 252);
  font-size: 10pt;
  z-index: 500;
}

/**************************** DESKTOP *******************************************************************************/
.panel {
  margin: 8px 8px 8px 8px;
}

.tarjeta-contenedor {
  background-color: white;
  width: 100%;
  height: 100%;
}
.tarjeta-contenedor .img-cvv {
  height: 37px;
  max-height: 37px;
}
.tarjeta-contenedor .tarjeta-cabecera {
  text-align: center;
  align-content: center;
  vertical-align: middle;
  padding: 8px;
  background-color: #52d05b;
  width: 100%;
  height: 70px;
  overflow: hidden;
  box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.tarjeta-contenedor .tarjeta-cabecera .cabecera-texto {
  position: relative;
  color: #ffffff;
  font-weight: bold;
  top: 8px;
}
.tarjeta-contenedor .tarjeta-cuerpo {
  height: calc(100% - 70px);
}
.tarjeta-contenedor .tarjeta-cuerpo .tarjeta-formulario {
  padding: 8px;
}
.tarjeta-contenedor .tarjeta-cuerpo .tarjeta-formulario .logo-cc {
  position: relative;
  top: -4px;
  color: #5f5f5f;
}
.tarjeta-contenedor .tarjeta-cuerpo .contenedor-conceptos {
  padding: 8px;
}
.tarjeta-contenedor .tarjeta-cuerpo .contenedor-conceptos-desktop {
  background-color: #efefef;
  padding: 8px;
  min-height: 100%;
  height: 100%;
  box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);
  z-index: 50;
}
.tarjeta-contenedor .tarjeta-cuerpo .contenedor-conceptos-desktop .btn-volver {
  align-self: center;
  padding-top: 10px;
}
.tarjeta-contenedor .cvv-hint {
  position: relative;
  top: -22px;
}
.tarjeta-contenedor .imagen-stripe {
  width: 320px;
  margin-top: 50px;
  align-self: center;
}
.tarjeta-contenedor mat-form-field {
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 12px;
}
.tarjeta-contenedor mat-form-field .mat-form-field-outline-start {
  border: solid 2px #ccc;
}

/**************************** MOBILE *******************************************************************************/
.tarjeta-contenedor-mobile {
  background-color: white;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}
.tarjeta-contenedor-mobile .img-cvv {
  height: 37px;
  max-height: 37px;
}
.tarjeta-contenedor-mobile .tarjeta-cabecera-mobile {
  position: fixed;
  text-align: center;
  align-content: center;
  vertical-align: middle;
  padding: 8px;
  background-color: #52d05b;
  width: 100%;
  height: 70px;
  overflow: hidden;
  box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.tarjeta-contenedor-mobile .tarjeta-cabecera-mobile .cabecera-texto {
  position: relative;
  color: #ffffff;
  font-weight: bold;
  top: 8px;
}
.tarjeta-contenedor-mobile .tarjeta-cuerpo {
  padding-top: 80px;
  height: 100vh;
}
.tarjeta-contenedor-mobile .tarjeta-cuerpo .tarjeta-formulario {
  padding: 8px;
}
.tarjeta-contenedor-mobile .tarjeta-cuerpo .tarjeta-formulario .logo-cc {
  position: relative;
  top: -4px;
  color: #ffffff;
}
.tarjeta-contenedor-mobile .tarjeta-cuerpo .contenedor-conceptos {
  padding: 8px;
}
.tarjeta-contenedor-mobile .tarjeta-cuerpo .contenedor-conceptos-desktop {
  background-color: #f3f3f3;
  padding: 8px;
  min-height: 100%;
  height: 100%;
  box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);
  z-index: 50;
}
.tarjeta-contenedor-mobile .tarjeta-cuerpo .contenedor-conceptos-desktop .btn-volver {
  align-self: center;
  padding-top: 10px;
}
.tarjeta-contenedor-mobile .cvv-hint {
  position: relative;
  top: -22px;
}
.tarjeta-contenedor-mobile .imagen-stripe.movil {
  width: 320px;
  margin-top: 20px;
  align-self: center;
}
.tarjeta-contenedor-mobile mat-form-field {
  margin-left: 0;
  margin-right: 0;
  margin-top: 12px;
}
.tarjeta-contenedor-mobile mat-form-field .mat-form-field-outline-start {
  border: solid 2px #ccc;
}

/**************************** EXTRA *******************************************************************************/
mat-hint {
  font-style: italic;
  font-weight: bold;
  font-size: 0.75rem;
}

.alto30 {
  height: 30px !important;
  min-height: 30px !important;
}

.alto60 {
  height: 60px !important;
  min-height: 60px !important;
}

.alto100 {
  height: 100vh !important;
  min-height: 100vh !important;
}

.pagar {
  align-self: center !important;
  width: 90% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/componentes/pasarela-stripe/pasarela-stripe.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA,qHAAA;AACA;EAGC,uBAAA;AADD;;AAGA;EACE,uBAAA;EACA,WAAA;EACA,YAAA;AAAF;AAEE;EACE,YAAA;EACA,gBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,8CAAA;EACA,YAAA;AADJ;AAGI;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,QAAA;AADN;AAIE;EACE,yBAAA;AAFJ;AAGI;EACE,YAAA;AADN;AAEM;EACE,kBAAA;EACA,SAAA;EACA,cAAA;AAAR;AAII;EACE,YAAA;AAFN;AAII;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EAGA,+CAAA;EACA,WAAA;AAFN;AAGM;EACE,kBAAA;EACA,iBAAA;AADR;AAKE;EACE,kBAAA;EACA,UAAA;AAHJ;AAME;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;AAME;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;AAMI;EACE,sBAAA;AAJN;;AAQA,oHAAA;AAEA;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AANF;AAQE;EACE,YAAA;EACA,gBAAA;AANJ;AAaE;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,8CAAA;EACA,YAAA;AAXJ;AAaI;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,QAAA;AAXN;AAcE;EACE,iBAAA;EAEA,aAAA;AAbJ;AAcI;EACE,YAAA;AAZN;AAaM;EACE,kBAAA;EACA,SAAA;EACA,cAAA;AAXR;AAeI;EACE,YAAA;AAbN;AAeI;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EAGA,+CAAA;EACA,WAAA;AAbN;AAcM;EACE,kBAAA;EACA,iBAAA;AAZR;AAgBE;EACE,kBAAA;EACA,UAAA;AAdJ;AAiBE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AAfJ;AAiBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAfJ;AAiBI;EACE,sBAAA;AAfN;;AAoBA,mHAAA;AACA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,uBAAA;EACA,2BAAA;AAjBF;;AAmBA;EACE,uBAAA;EACA,2BAAA;AAhBF;;AAmBA;EACE,wBAAA;EACA,4BAAA;AAhBF;;AAkBA;EACE,6BAAA;EACA,qBAAA;AAfF","sourcesContent":[".close-button {\n  position: fixed;\n  top: 8px;\n  right: 6px;\n  color: rgb(252, 252, 252);\n  font-size: 10pt;\n  z-index: 500;\n}\n\n/**************************** DESKTOP *******************************************************************************/\n.panel{\n\t// box-shadow: none;\n\t// border-bottom: 1px solid rgb(114, 114, 114);\n\tmargin: 8px 8px 8px 8px;\n}\n.tarjeta-contenedor {\n  background-color: white;\n  width: 100%;\n  height: 100%;\n\n  .img-cvv {\n    height: 37px;\n    max-height: 37px;\n  }\n\n  .tarjeta-cabecera {\n    text-align: center;\n    align-content: center;\n    vertical-align: middle;\n    padding: 8px;\n    background-color: #52d05b;\n    width: 100%;\n    height: 70px;\n    overflow: hidden;\n    -webkit-box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);\n    -moz-box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);\n    box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);\n    z-index: 100;\n\n    .cabecera-texto {\n      position: relative;\n      color: #ffffff;\n      font-weight: bold;\n      top: 8px;\n    }\n  }\n  .tarjeta-cuerpo {\n    height: calc(100% - 70px);\n    .tarjeta-formulario {\n      padding: 8px;\n      .logo-cc {\n        position: relative;\n        top: -4px;\n        color: #5f5f5f;\n      }\n    }\n\n    .contenedor-conceptos {\n      padding: 8px;\n    }\n    .contenedor-conceptos-desktop {\n      background-color: #efefef;\n      padding: 8px;\n      min-height: 100%;\n      height: 100%;\n      -webkit-box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);\n      -moz-box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);\n      box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);\n      z-index: 50;\n      .btn-volver {\n        align-self: center;\n        padding-top: 10px;\n      }\n    }\n  }\n  .cvv-hint {\n    position: relative;\n    top: -22px;\n  }\n\n  .imagen-stripe {\n    width: 320px;\n    margin-top: 50px;\n    align-self: center;\n  }\n  mat-form-field {\n    margin-left: 15px;\n    margin-right: 15px;\n    margin-top: 12px;\n\n    .mat-form-field-outline-start {\n      border: solid 2px #ccc;\n    }\n  }\n}\n/**************************** MOBILE *******************************************************************************/\n\n.tarjeta-contenedor-mobile {\n  background-color: white;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n\n  .img-cvv {\n    height: 37px;\n    max-height: 37px;\n  }\n  // .nombre{\n  //   padding-left: 10px !important;\n  //   padding-right: 10px !important;\n  // }\n\n  .tarjeta-cabecera-mobile {\n    position: fixed;\n    text-align: center;\n    align-content: center;\n    vertical-align: middle;\n    padding: 8px;\n    background-color: #52d05b;\n    width: 100%;\n    height: 70px;\n    overflow: hidden;\n    -webkit-box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);\n    -moz-box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);\n    box-shadow: 0px 1px 3px 2px rgba(0, 0, 0, 0.6);\n    z-index: 100;\n\n    .cabecera-texto {\n      position: relative;\n      color: #ffffff;\n      font-weight: bold;\n      top: 8px;\n    }\n  }\n  .tarjeta-cuerpo {\n    padding-top: 80px;\n    // height: calc(100% - 70px);\n    height: 100vh;\n    .tarjeta-formulario {\n      padding: 8px;\n      .logo-cc {\n        position: relative;\n        top: -4px;\n        color: #ffffff;\n      }\n    }\n\n    .contenedor-conceptos {\n      padding: 8px;\n    }\n    .contenedor-conceptos-desktop {\n      background-color: #f3f3f3;\n      padding: 8px;\n      min-height: 100%;\n      height: 100%;\n      -webkit-box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);\n      -moz-box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);\n      box-shadow: -1px 4px 3px 1px rgba(0, 0, 0, 0.6);\n      z-index: 50;\n      .btn-volver {\n        align-self: center;\n        padding-top: 10px;\n      }\n    }\n  }\n  .cvv-hint {\n    position: relative;\n    top: -22px;\n  }\n\n  .imagen-stripe.movil {\n    width: 320px;\n    margin-top: 20px;\n    align-self: center;\n  }\n  mat-form-field {\n    margin-left: 0;\n    margin-right: 0;\n    margin-top: 12px;\n\n    .mat-form-field-outline-start {\n      border: solid 2px #ccc;\n    }\n  }\n}\n\n/**************************** EXTRA *******************************************************************************/\nmat-hint {\n  font-style: italic;\n  font-weight: bold;\n  font-size: 0.75rem;\n}\n\n.alto30 {\n  height: 30px !important;\n  min-height: 30px !important;\n}\n.alto60 {\n  height: 60px !important;\n  min-height: 60px !important;\n}\n\n.alto100 {\n  height: 100vh !important;\n  min-height: 100vh !important;\n}\n.pagar {\n  align-self: center !important;\n  width: 90% !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
